import { render, staticRenderFns } from "./EstadoInscripcionDialog.vue?vue&type=template&id=2410c4b4&scoped=true&"
import script from "./EstadoInscripcionDialog.vue?vue&type=script&lang=js&"
export * from "./EstadoInscripcionDialog.vue?vue&type=script&lang=js&"
import style0 from "./EstadoInscripcionDialog.vue?vue&type=style&index=0&id=2410c4b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2410c4b4",
  null
  
)

export default component.exports